// src/admin/legal/LegalSummary.jsx — «In vigore»: the version of each document in effect, with its links; a warning
// when none is (acceptances of that document are then NOT recorded — the page's main job is to make that visible).
// ⚠️ "none in effect" ≠ "none configured": a scheduled version is named (summaryOf's `next`).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { summaryOf, documentLabelKey, formatDateTime } from './legalModel.js';
import VersionLinks from './VersionLinks.jsx';
import { COLORS, RADII, SEMANTIC } from '../../constants/theme.js';

const CARD = {
  background: COLORS.surface, borderRadius: RADII.control, border: `1px solid ${COLORS.border}`,
  padding: '16px 20px', marginBottom: '20px',
};
const LINE = { display: 'grid', gridTemplateColumns: '200px 1fr', gap: '12px', alignItems: 'start', padding: '6px 0' };

export default function LegalSummary({ list }) {
  const { t, i18n } = useTranslation('admin');
  const titleId = 'legal-summary-title';
  return (
    <section aria-labelledby={titleId} style={CARD}>
      <h2 id={titleId} style={{ fontSize: '14px', fontWeight: 700, margin: '0 0 8px', color: COLORS.ink }}>
        {t('legalDocuments.summary.title')}
      </h2>
      {summaryOf(list).map(({ document, version, row, next }) => (
        <div key={document} style={LINE}>
          <span style={{ fontSize: '13px', fontWeight: 600 }}>{t(documentLabelKey(document))}</span>
          {version !== null ? (
            <span style={{ display: 'flex', gap: '16px', alignItems: 'center', fontSize: '13px' }}>
              <strong>{version}</strong>
              <VersionLinks row={row} />
            </span>
          ) : (
            <span style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', color: SEMANTIC.attenzione.fg, fontSize: '13px' }}>
              <AlertTriangle size={16} aria-hidden style={{ flexShrink: 0, marginTop: '1px' }} />
              <span>
                <span style={{ display: 'block' }}>{t('legalDocuments.summary.none')}</span>
                {next && (
                  <span style={{ display: 'block' }}>
                    {t('legalDocuments.summary.next', {
                      version: next.version, date: formatDateTime(next.effective_from, i18n.language),
                    })}
                  </span>
                )}
              </span>
            </span>
          )}
        </div>
      ))}
    </section>
  );
}
